import AxiosInstance from '../config/AxiosInstance';
import AxiosInstanceFormData from '../config/AxiosInstanceFormData';


const getGroupProduct = async (companyId: any, page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/product-groups/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getGroupProductDashboard = async (companyId: any, page: any, limit: any, searchCode: any, searchName: any, searchDisplayName: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/product-groups/list-for-dashboard', {
            params: {
                page: page,
                limit: limit,
                searchCode: searchCode,
                searchName: searchName,
                searchDisplayName: searchDisplayName,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListUOM = async (userId: any, page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/uom/list-base', {
            params: {
                userId: userId,
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListUOMAlt = async (baseUOMId: any, page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/uom/list-alternative', {
            params: {
                baseUOMId: baseUOMId,
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getForListUOMAlt = async (productId: any, page: any, limit: any, searchValue: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/uom/list-uom-for-supplier', {
            params: {
                productId: productId,
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}



const createGroupProduct = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/product-groups', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateGroupProduct = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/inventory/product-groups/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateStatusProduct = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/inventory/products/update-status/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}


const createProduct = async (payload: FormData) => {
    try {
        const { data } = await AxiosInstanceFormData.post('/api/inventory/products', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

/**
 * Resolves the country-scoped quick-add defaults for the authenticated
 * user's company. Returned shape:
 *   { countryId, defaultTaxGroupId, defaultBaseUomId, defaultBaseUomName,
 *     defaultProductType, defaultPriceType, defaultCost }
 * 404 means no country defaults configured — the Quick Add button
 * should be disabled (the backend will refuse the create either way).
 */
const getQuickAddDefaults = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/quick-add/defaults');
        return { data };
    } catch (error) {
        throw error;
    }
}

/**
 * Quick-add a product. The server fills SKU (QA-NNNNN), type, tax group,
 * base UOM, cost, price type and validity window from country defaults.
 * Payload is plain JSON (NOT multipart) — no image upload.
 */
const quickAddProduct = async (payload: {
    productName: string;
    price: number;
    productGroupId: string;
    attributeIds?: string[];
    barcode?: string;
    userId?: string;
}) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/products/quick-add', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

/**
 * Simple price change: creates a NEW price record effective from the given
 * day (default today) and end-dates the current one server-side. History is
 * preserved — never edits past rows.
 */
const changeProductPrice = async (payload: {
    productId: string;
    newPrice: number;
    effectiveFrom?: string | null;
}) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/product-price/change', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

/**
 * Bulk price change from the Items list selection. Same semantics as
 * changeProductPrice, once per product id, applied server-side in one call so
 * the whole set lands together. Products that have never been priced are NOT
 * sent by the caller — there is no current row to end-date. The response
 * reports how many rows were written and which ids the server skipped.
 */
const changeProductPriceBulk = async (payload: {
    productIds: string[];
    newPrice: number;
    effectiveFrom?: string | null;
}) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/product-price/change-bulk', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

/**
 * Bulk delete from the Items list selection. Soft-deletes each product the
 * caller is allowed to remove and reports the ones it had to skip (still
 * referenced by a recipe / promotion / open order) rather than failing the
 * whole batch. Body is { ids } — DeleteBulkProductsDto on the API — unlike
 * change-bulk, which takes { productIds }.
 */
const deleteProductsBulk = async (payload: { ids: string[] }) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/products/delete-bulk', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailProduct = async (id: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/find-one/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailProductGroup = async (id: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/product-groups/find-one/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}


const updateProduct = async (id: any, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/inventory/products/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getCourses = async (activeOnly?: boolean) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/courses', {
            params: activeOnly !== undefined ? { active: activeOnly } : undefined,
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

const getListProduct = async (page: any, limit: any, searchValue: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

/**
 * `search` is the single free-text box on the redesigned Items list: the API
 * matches it against name, SKU and barcode. `sortBy` is one of
 * name | sku | updated | created | status | type | group (never price — an
 * item's price lives in a history table with validity windows, so there is no
 * single sortable value), `sortDir` is ASC | DESC.
 */
const getListProductDashboard = async (page: any, limit: any, searchType: any, searchName: any, searchSku: any, searchGroup: any, searchTime: any, searchStatus: any, companyId: any, search?: any, sortBy?: any, sortDir?: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/list-for-dashboard', {
            params: {
                page: page,
                limit: limit,
                searchType: searchType,
                searchSku: searchSku,
                searchName: searchName,
                searchGroup: searchGroup,
                searchTime: searchTime,
                searchStatus: searchStatus,
                search: search,
                sortBy: sortBy,
                sortDir: sortDir,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getSockHolding = async (page: any, limit: any, search: any, location: any, productId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/stock/list-for-recipes', {
            params: {
                page: page,
                limit: limit,
                search: search,
                location: location,
                productId: productId
            }
        });
        return { data };
    } catch (error) {
        console.error('Error fetching countries:', error);
        throw error;
    }
};

const getListProductWithLocation = async (page: any, limit: any, searchValue: any, locationId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/products/listWithLocationId', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
                locationId: locationId
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListProductWithOrderTemplate = async (page: any, limit: any, searchValue: any, locationId: any, orderId: any, productGroupId?: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/orders/getOrderTemplateDetailsByOrderId', {
            params: {
                searchValue: searchValue,
                orderId: orderId,
                locationId: locationId,
                page: page,
                limit: limit,
                productGroupId: productGroupId || undefined,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListProductWithSupplierReturn = async (page: any, limit: any, searchValue: any, supplierReturnId: any, orderId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/orders/list-order-details/' + orderId, {
            params: {
                searchValue: searchValue,
                page: page,
                limit: limit,
                supplierReturnId: supplierReturnId,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}



const deleteProduct = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/inventory/products/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteGroup = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/inventory/product-groups/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}


const getListSystemAccount = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/system-accounts', {
            params: {
                page: 1,
                limit: 100
            }
        }
        );
        return { data };
    } catch (error) {
        throw error;
    }
}


const getTax = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/taxes/list', {
            params: {
                page: payload.page,
                limit: payload.limit,
                searchValue: payload.searchValue,
                sort: payload.sort,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

/** Tax groups for current company (country-scoped); use id as taxGroupId on product prices. */
const getTaxGroupsForProductPrices = async () => {
    const { data } = await AxiosInstance.get('/api/inventory/products/tax-groups/list');
    return data?.data ?? [];
}

const createTax = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/taxes', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateTax = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/taxes/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteTax = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/taxes/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailTax = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/taxes/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}
const getAssetsCategory = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases/asset-category/list');
        return { data };
    } catch (error) {
        throw error;
    }
};

/** List print groups (global + company) for product configuration print destinations. */
const getPrintGroups = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/print-groups');
        return data?.data ?? [];
    } catch (error) {
        throw error;
    }
};

export {
    getListUOM,
    getDetailProductGroup,
    getListSystemAccount,
    createGroupProduct,
    getGroupProduct,
    updateGroupProduct,
    getDetailProduct,
    createTax,
    getTax,
    getTaxGroupsForProductPrices,
    updateTax,
    deleteTax,
    getDetailTax,
    changeProductPrice,
    changeProductPriceBulk,
    deleteProductsBulk,
    createProduct,
    updateProduct,
    getListProduct,
    deleteGroup,
    deleteProduct,
    getAssetsCategory,
    getListProductWithLocation,
    getListProductWithOrderTemplate,
    getSockHolding,
    getGroupProductDashboard,
    getListProductDashboard,
    updateStatusProduct,
    getListUOMAlt,
    getListProductWithSupplierReturn,
    getForListUOMAlt,
    getCourses,
    getPrintGroups,
    getQuickAddDefaults,
    quickAddProduct,
}